<template>
  <div>
    <mheader></mheader>
    <!-- <article-category></article-category> -->
    <div class="breadcrumb">
      <router-link to="/">Home</router-link> / <router-link to="/article">Article List</router-link> / {{article.title}}
      <!-- <a-breadcrumb>
        <a-breadcrumb-item><router-link to="/">Home</router-link></a-breadcrumb-item>
        <a-breadcrumb-item><router-link to="/article">Article List</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>{{article.title}}</a-breadcrumb-item>
      </a-breadcrumb> -->
    </div>
    <h1 class="breadcrumb">{{article.title}}</h1>
    <p class="otherInfo">
      <span>
        <a-icon type="fire" style="margin-right: 5px" />
        {{article.traffic}}
      </span><span class="split">|</span>
      <span>
        <a-icon type="heart" style="margin-right: 5px" />
        {{article.love}}
      </span><span class="split">|</span>
      <span>{{article.createBy}}</span><span class="split"></span>
      <span class="category">{{article.categoryName}}</span><br />
      <span class="tags" v-for="item in article.tags" :key="item.name">{{item.name}}</span>
    </p>
    <p class="summary">{{article.summary}}</p>
    <!-- <mavon-editor v-model="value" :language="language" :boxShadow="false" :subfield="false" defaultOpen="preview" :editable="true" :toolbarsFlag="true" :toolbars="toolbars" /> -->
    <!-- <p>创建时间：</p>
    <p>最后修改：{{article.modifiedBy}}</p> -->


    <img v-if="article.pictureUrl" width="598" :src="article.pictureUrl" />

    <!-- <div class="breadcrumb" v-html="article.content"></div> -->
    <div class="content">
      <VueShowdown
        :markdown="article.content"
        flavor="github"
        :options="{ emoji: true }"/>
    </div>

    <div class="love">
      <span v-if="loved == 0" class="button"  @click="love(article.id)"><a-icon type="heart" style="margin-right: 5px" />喜欢</span>
      <span v-else class="loved" @click="thanksLoved()"><a-icon type="heart" style="margin-right: 5px" />喜欢</span>
    </div>
    
    <mfooter></mfooter>
  </div>
</template>

<script>
// import toolbars from './../tools/mavon-markdown-config'

import axios from '@/api';
import Mheader from '@/components/Mheader';
import Mfooter from '@/components/Mfooter';

export default {
  components: {
      Mheader,
      Mfooter,
  },
  data() {
    return {
      value: '# index',
      article: {
        content: ''
      },
      loved: 0,
    }
  },
  computed: {
    language() {
      return localStorage.lang == 'en-US' ? 'en' : localStorage.lang;
    }
  },
  methods: {
    love(id) {
      axios.articleLove(id).then((res) => {
        this.loved = res.data;
      })
    },
    thanksLoved() {
      console.log(this)
      this.$message.open({
        content: '已经喜欢过啦～！感谢厚爱',
        icon: <a-icon style="color: #f88070;" type="heart" />
      })
    }
  },
  mounted() {
    axios.getArticle(this.$route.params.id).then(res => {
      this.article = res.data;
    });
  }
}
</script>
<style>
.content h1,h2,h3,h4,h5,h6 {
  color: rgba(255, 255, 255, .85)!important;
}
</style>

<style scoped>
.breadcrumb {
  margin-top: 3rem;
  color: #ccc;
}
.breadcrumb a {
  color: #999;
}
.breadcrumb a:hover {
  color: #1890ff;
}
.split {
  display: inline-block;
  padding: 0 8px;
  color: #ccc;
}
.otherInfo {
  font-size: 14px;
}
.category {
  font-size: 14px;
  display: inline-block;
  background:#333;
  color: #fff;
  padding: 3px 8px;
  margin-right: 1rem;
  border-radius: 2px;
}
.tags {
  display: inline-block;
  padding: 1px 1.5px;
  margin-right: .5rem;
  border: 1px solid #191919;
  background: #242424;
  border-radius: 2px;
}
.summary {
  line-height: 1.5rem;
  margin: 1rem 0;
  text-indent: 2em;
  background: rgba(1, 1, 1, .05);
  padding: 1rem;
}
.content {
  margin-top: 3rem;
}

.love {
  text-align: center;
  margin: 3rem;
}
.love .button {
  display: inline-block;
  color: #f88070;
  border: 1px solid #f88070;
  border-radius: 3px;
  background-color: #fff;
  padding: .4rem 1rem;
  cursor: pointer;
  
}

.love .loved {
  display: inline-block;
  color: #fff;
  border: 1px solid #f88070;
  border-radius: 3px;
  background-color: #f88070;
  padding: .4rem 1rem;
  cursor: pointer;
  
}
</style>
